import React from 'react';
import { FilterTab, FilterTabs, Header } from './ReelFeedHeader.styles';

const ReelFeedHeader = ({ activeTab, tabs, onTabClick, topOffset = 0 }) => {
  return (
    <Header style={{ top: `${topOffset + 16}px` }}>
      <FilterTabs>
        <FilterTab type="button" $active={activeTab === tabs.TRENDING} onClick={() => onTabClick(tabs.TRENDING)}>
          Trending
        </FilterTab>
        <FilterTab type="button" $active={activeTab === tabs.NEW} onClick={() => onTabClick(tabs.NEW)}>
          New
        </FilterTab>
      </FilterTabs>
    </Header>
  );
};

export default ReelFeedHeader;
